import { debouncify } from './debouncify';
export function debounce(delayMs) {
    return (target, propertyName, descriptor) => {
        if (descriptor.value) {
            const methodsMap = new WeakMap();
            const originalMethod = descriptor.value;
            descriptor.value = function (...args) {
                if (!methodsMap.has(this)) {
                    methodsMap.set(this, debouncify(originalMethod, delayMs).bind(this));
                }
                methodsMap.get(this)(...args);
            };
            return descriptor;
        }
        throw new Error('@debounce is applicable only on a methods.');
    };
}
